import { Injectable, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CreateComponent } from '../create/create.component';

@Injectable()
export abstract class CreateModalComponent<T> extends CreateComponent<T> {
  /**
   * Reference to the actual template. This uses 'template' as template name.
   */
  @ViewChild('template')
  public template: TemplateRef<any>;

  /**
   * Reference (ModalRef) to the actual modal.
   */
  public modalRef: NgbModalRef;

  constructor(protected modalService: NgbModal, private readonly options?: NgbModalOptions) {
    super();
  }

  /**
   * This function calls, when the modal starts opening.
   */
  public openModal() {
    this.stopLoading();
    if (this.beforeOpen) {
      this.beforeOpen();
    }
    this.modalRef = this.modalService.open(this.template, this.options);
  }

  /**
   * This function calls, when the modal starts closing.
   */
  public closeModal() {
    if (this.beforeClose) {
      this.beforeClose();
    }
    this.modalRef.close();
    this.modalRef = null;
  }

  protected abstract initModel(): T;
  protected abstract createModel(): Observable<T>;
}

export interface CreateModalComponent<T> {
  /**
   * This function starts during the modal is closing.
   */
  beforeClose?(): void;

  /**
   * This function starts during the modal is opening.
   */
  beforeOpen?(): void;
}
